import { Component } from '@angular/core';

@Component({
  selector: 'app-contractor-dashboard',
  templateUrl: './contractor-dashboard.component.html',
  styleUrl: './contractor-dashboard.component.scss',
})
export class ContractorDashboardComponent {
  firstName: string = '';
  lastName: string = '';

  constructor() {
    const userProfileString = sessionStorage.getItem('userProfile');
    if (userProfileString) {
      try {
        const userProfile = JSON.parse(userProfileString);
        this.firstName = userProfile.firstName || '';
        this.lastName = userProfile.lastName || '';
      } catch (e) {
        console.error('Error parsing user profile from session storage:', e);
      }
    }
  }
}
